export { AddToCartFeatureMobile } from './add-to-card';
